const { config } = require('@sstdev/lib_metadata-config');
// By linking the blockGroups index.js file, which references all blockGroup files,
// those are loaded, and therefore registered to the registry:
const blockGroups = require('./blockGroups');

/**
 *
 * @param {{hNodes:[]}}} useCaseMetadata
 * @returns {{
 *  accessDefinition:{
 *      [pageId:string]:import('./registry').PageAccessTarget
 *  },
 *  systemRoles:{
 *      _id:string, system:boolean,
 *      title:string,
 *      description:string,
 *      access:{
 *          defaultAccess:boolean,
 *          rights:import('./registry').RoleAccess
 *      }
 *  }
 * }}
 */
function extractAccess(useCaseMetadata) {
    /**
     * @type {{
     *   spec: import('./registry').PageAccessTarget[],
     *   access: import('./registry').RoleAccess
     * }}
     */
    const { spec, access } = blockGroups.hNode.extractAccess(useCaseMetadata.hNodes, {
        roles: ['USER', 'ADMIN', 'SUPPORT']
    });

    return {
        accessDefinition: spec.reduce((acc, menuEntry) => {
            acc[menuEntry.pageId] = menuEntry;
            return acc;
        }, {}),
        systemRoles: [
            {
                _id: config.systemRoles.USER,
                system: true,
                title: 'USER',
                description: 'Default User Role',
                access: {
                    defaultAccess: false,
                    rights: access.USER
                }
            },
            {
                _id: config.systemRoles.ADMIN,
                system: true,
                title: 'ADMIN',
                description: 'Default Admin Role',
                access: {
                    defaultAccess: true,
                    rights: access.ADMIN
                }
            },
            {
                _id: config.systemRoles.SYSTEM,
                system: true,
                title: 'SUPPORT',
                description: 'Default Support Role',
                access: {
                    defaultAccess: true,
                    rights: access.SUPPORT
                }
            }
        ]
    };
}

/**
 *
 * @param {{hNodes:[]}} metadata
 * @param {{
 *      _id:string, system:boolean,
 *      title:string,
 *      description:string,
 *      access:{
 *          defaultAccess:boolean,
 *          rights: import('./registry').PagesAccess
 *      }
 *  }} role
 * @returns {{hNodes:[]}}
 */
function redact(metadata, role) {
    const redactedHNodes = blockGroups.hNode.redact(metadata.hNodes, role.access.rights, role.access.defaultAccess);

    return {
        ...metadata,
        hNodes: redactedHNodes
    };
}

module.exports = { extractAccess, redact };
